import axios from 'axios'
import { Auth } from '@aws-amplify/auth'
import { readCurrentOrganization } from '../../shared/utils/storageUtils'

const basePath = new URL(window.location.href).origin

// Create the base API client
const apiClient = axios.create({
  baseURL: `${basePath}/integrations`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Function to get the JWT token
const getJwtToken = async (): Promise<string | null> => {
  try {
    const session = await Auth.currentSession()
    return session.getAccessToken().getJwtToken()
  } catch (error) {
    console.error('Error getting JWT token:', error)
    return null // Return null if the token cannot be retrieved
  }
}

// Function to get the current organization's external ID
const getCurrentOrganizationExternalId = (): string | null => {
  const currentOrganization = readCurrentOrganization()
  return currentOrganization?.externalId || null
}

// Add a request interceptor to inject the auth token and organization ID
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const authToken = await getJwtToken()
      const organizationId = getCurrentOrganizationExternalId()

      // Ensure the auth token is in the correct format
      if (authToken) {
        config.headers['Authorization'] = `Bearer ${authToken.trim()}`
      } else {
        console.warn('Auth token is missing or invalid.')
      }

      // Add the organization ID to the headers if available
      if (organizationId) {
        config.headers['X-Organization-Id'] = organizationId
      }

      return config
    } catch (error) {
      console.error('Error in request interceptor:', error)
      return Promise.reject(error)
    }
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Add a response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    console.log('apiClient response interceptor - Full response:', response)
    console.log('apiClient response interceptor - response.data:', response.data)
    return response.data
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message)
    console.error('API Error - Full error object:', error)
    return Promise.reject(error.response?.data || error.message)
  },
)

export default apiClient
